export function toApiPayload(formData: any, assetId?: string, inspectionId?: string) {
	const subAssetId =
		formData.subAssetId &&
		(formData.assetId === formData.subAssetId || assetId === formData.subAssetId)
			? undefined
			: formData.subAssetId;

	return {
		// Inject inspectionId if provided
		...(inspectionId && { inspectionId }),
		...(assetId && { assetId }),

		subAssetId: subAssetId,
		// --- Core Fields ---
		title: formData.title,
		description: formData.description,
		remarkId: formData.remarkId,
		statusId: formData.statusId,

		// --- Renaming & Mapping ---

		// UI: damageClass -> Backend: class
		class: formData.damageClass || formData.class || '',

		// UI: objectCategory -> Backend: category
		categoryId: formData.categoryId,

		// UI: objectSubCategory -> Backend: subCategory
		subCategoryId: formData.subCategoryId,

		// --- Grouped Fields (Split Logic) ---

		// Material
		materialId: formData.materialId,

		// Type (UI: damageType -> Backend: type)
		damageTypeId: formData.damageTypeId,

		// --- Dimensions ---

		// Combine length & unit into nested object
		lengthArea: {
			length: Number(formData.length) || 0,
			massureType: formData.lengthUnit || 'cm', // Preserving 'massureType' typo as requested
		},
		extentId: formData.extentId,

		// --- Location Fields ---

		// UI: longitudinalPosition -> Backend: longitudinalLocation
		longitudinalId: formData.longitudinalId,

		// UI: transversePosition -> Backend: transverseLayer
		transverseId: formData.transverseId,

		// UI: verticalPosition -> Backend: elevation
		elevationId: formData.elevationId,

		// UI: existingDamageStatus -> Backend: previouseDamageStatus
		previousDamageStatusId: formData.previousDamageStatusId,
	};
}
